'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var PropTypes = require('prop-types');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var _excluded = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PaypalIcon = function PaypalIcon(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Paypal' : _ref$title,
    props = _objectWithoutProperties__default.default(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsxs("svg", _objectSpread(_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 1536 1024",
    title: title,
    role: "img"
  }, props), {}, {
    children: [/*#__PURE__*/jsxRuntime.jsx("title", {
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M519.763 518.667c0 32.667-25.422 57.333-57.363 57.333-24.119 0-41.719-14-41.719-40 0-32.667 24.77-58.667 56.711-58.667 24.119 0 42.37 15.333 42.37 41.333zM1031.467 419.333c0 40-23.467 48-57.363 48l-20.859 0.667 11.081-71.333c0.652-4.667 3.911-7.333 8.474-7.333h11.733c22.163 0 46.933 1.333 46.933 30zM1260.267 518.667c0 32.667-25.422 57.333-56.711 57.333-24.118 0-42.37-14-42.37-40 0-32.667 24.77-58.667 56.711-58.667 24.119 0 42.37 15.333 42.37 41.333zM368.533 404.667c0-56-42.37-74.667-90.607-74.667h-104.296c-6.519 0-13.037 5.333-13.689 12.667l-42.37 272c-0.652 5.333 3.259 10.667 8.474 10.667h49.541c7.17 0 13.689-5.333 14.341-12.667l11.733-73.333c2.607-19.333 34.548-12.667 46.933-12.667 74.311 0 119.941-45.333 119.941-122zM569.956 612.667l26.726-174c0.652-5.333-3.259-10.667-8.474-10.667h-49.541c-9.778 0-10.43 14.667-11.081 22-14.993-22.667-37.156-26.667-61.926-26.667-63.881 0-112.77 57.333-112.77 120.667 0 52 31.941 86 82.785 86 23.467 0 52.8-10.667 69.096-29.333-1.304 4-2.607 10-2.607 14 0 6 2.607 10.667 8.474 10.667h44.978c7.17 0 13.037-5.333 14.341-12.667zM861.333 437.333c0-4.667-3.911-9.333-8.474-9.333h-50.193c-4.563 0-9.126 2.667-11.733 6.667l-69.096 104-28.682-100c-1.956-6-7.822-10.667-14.341-10.667h-48.889c-4.563 0-8.474 4.667-8.474 9.333 0 3.333 50.844 154 55.407 168-7.17 10-53.452 72-53.452 80 0 4.667 3.911 8.667 8.474 8.667h50.193c4.563 0 9.126-2.667 11.733-6.667l166.222-245.333c1.304-1.333 1.304-2.667 1.304-4.667zM1109.037 404.667c0-56-42.37-74.667-90.607-74.667h-103.644c-7.17 0-13.689 5.333-14.341 12.667l-42.37 272c-0.652 5.333 3.259 10.667 8.474 10.667h53.452c5.215 0 9.126-4 10.43-8.667l11.733-77.333c2.607-19.333 34.548-12.667 46.933-12.667 74.311 0 119.941-45.333 119.941-122zM1310.459 612.667l26.726-174c0.652-5.333-3.259-10.667-8.474-10.667h-49.541c-9.778 0-10.43 14.667-11.081 22-14.341-22.667-36.504-26.667-61.926-26.667-63.881 0-112.77 57.333-112.77 120.667 0 52 31.941 86 82.785 86 24.119 0 53.452-10.667 69.096-29.333-0.652 4-2.607 10-2.607 14 0 6 2.607 10.667 8.474 10.667h44.978c7.17 0 13.037-5.333 14.341-12.667zM1452.563 340v-0.667c0-5.333-3.911-9.333-8.474-9.333h-48.237c-3.911 0-7.822 3.333-8.474 7.333l-42.37 277.333-0.652 1.333c0 4.667 3.911 9.333 9.126 9.333h43.022c6.519 0 13.037-5.333 13.689-12.667l42.37-272.667zM289.659 429.333c-5.215 34-27.378 38-56.059 38l-21.511 0.667 11.081-71.333c0.652-4.667 4.563-7.333 8.474-7.333h12.385c29.333 0 51.496 4 45.63 40zM1536 85.333v853.333c0 46.667-37.807 85.333-83.437 85.333h-1334.993c-45.63 0-83.437-38.667-83.437-85.333v-853.333c0-46.667 37.807-85.333 83.437-85.333h1334.993c45.63 0 83.437 38.667 83.437 85.333z"
    })]
  }));
};
PaypalIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PaypalIcon",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Paypal'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var PaypalIcon$1 = PaypalIcon;
PaypalIcon.propTypes = {
  title: PropTypes__default.default.string
};

exports.default = PaypalIcon$1;
//# sourceMappingURL=PaypalIcon.js.map
